import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

export default class {

  constructor ($el) {
    this.$el = $el
    this.isOpen = false
    this.isReady = false
    this.componentId = this.getId()
    this.selected = null
    this.stepTitle = null
  }

  getId () {
    let id = this.$el.attr('id')
    if (!id) {
      return null
    }
    return parseInt(id.replace('component_', ''))
  }

  init () {
    if (!this.componentId) {
      return
    }
    $('.composite_data')
      .on( 'wc-composite-initializing', ( event, composite ) => {
        this.compositeManager = composite
        this.whenReady()
        this.compositeManager.actions.add_action( 'component_scripts_initialized', () => {
          let component = this.getComponentFromManager()
          if (component.step_id !== this.componentId) {
            return
          }
          this.stepTitle = component.step_title
          this.updateSelection(component)
        }, 100);
      this.compositeManager.actions.add_action( 'component_selection_changed', (component) => {
        if (component.step_id !== this.componentId) {
          return
        }
        this.updateSelection(component)
        this.triggerGallery(component)
        this.close()
      }, 100)
    });
  }

  whenReady () {
    if (this.isReady) {
      return
    }
    this.isReady = true
    this.buildClose()
    this.$close.on('click', () => {
      this.close()
    })
    this.$el.on('click', '.component_option_thumbnail', (e) => {
      $(e.currentTarget)
        .find('.component_option_thumbnail_select')
        .click()
    })

    // Append additional content
    if (window._composite_extra && window._composite_extra.notes) {
      let $desc = this.$el.find('.component_description_wrapper').first()
      $desc.append(`<div class="composite_description_notes text-sm text-gray-700 font-hairline">${window._composite_extra.notes}</div>`)
    }

  }

  open () {
    this.$el.addClass('is-open')
    this.buildOverlay()
    // this.$overlay.addClass('is-open')
    this.isOpen = true
  }

  close () {
    this.$el.removeClass('is-open')
    this.closeOverlay()
    // this.$overlay.removeClass('is-open')
    this.isOpen = false
  }

  buildOverlay () {
    this.$overlay = $('<div class="composite-overlay fixed inset-0 z-popup-overlay opacity-75 bg-white"></div>')
    this.$overlay.appendTo('body')
    disableBodyScroll(this.$el[0])
    this.$overlay.on('click', () => {
      this.close()
    })
  }

  closeOverlay () {
    if (!this.$overlay) {
      return
    }
    this.$overlay.off('click')
    this.$overlay.remove()
    enableBodyScroll(this.$el[0])
    this.$overlay = null
  }

  buildTrigger () {
    if (!this.$trigger) {
      this.$trigger = $(this.triggerTemplate())
      this.$trigger.insertAfter(this.$el)
      this.$trigger.on('click', () => {
        if (this.isOpen) {
          this.close()
          return
        }
        this.open()
      })
    }
    // just update internal content
    this.$trigger
      .find('.js-selected')
      .html(this.selectedTemplate(this.selected))

  }

  /**
   * Updates currently selected composite addon
   *
   * @param WC_CP_Component component
   */
  updateSelection (component) {
    this.selected = {
      title: component.get_selected_product_title(),
      image: component.get_selected_product_image_data(),
    }
    // Recreate our selected template which also serve as trigger
    this.buildTrigger()
  }

  /**
   * Propagate selection information to gallery script via global events
   */
  triggerGallery (component) {
    $(document).trigger('comf.gallery.update', [component])
  }

  /**
   * Retrieve component managed by this class from global Composite manager
   */
  getComponentFromManager () {
    if (!this.compositeManager) {
      return null
    }
    let components = this.compositeManager.get_components()
    for (let index = 0; index < components.length; index++) {
      const component = components[index];
      if (component.step_id === this.componentId) {
        return component
      }
    }
    return null
  }

  triggerTemplate () {
    return `
    <div class="mb-2 bg-gray-100 cursor-pointer border border-gray-500 hover:bg-gray-200 hover:border-black">
      <div class="js-selected"></div>
    </div>
    `
  }

  selectedTemplate (data) {
    return `
      <div class="flex w-full items-center px-3 py-2">
        <div class="w-12 mr-3 text-center">
          ${
            (data.image.image_src)
            ? `<img src="${data.image.image_src}" />`
            : '<span class="fal fa-exclamation-triangle text-gray-500" data-fa-transform="grow-12"></span>'
          }
        </div>
        <div>
          <div class="leading-tight">${this.stepTitle}</div>
          <div class="text-gray-600 truncate text-sm">${data.title}</div>
        </div>
        <div class="ml-auto">
          <span class="fal fa-angle-right inline-block ml-4"></span>
        </div>
      </div>
    `
  }

  buildClose () {
    this.$close = $(this.closeTemplate())
    this.$close.prependTo(this.$el)
  }

  closeTemplate () {
    return `
      <button class="cursor-pointer absolute top-0 right-0 w-8 h-8 mt-3 mr-3 rounded-full border border-gray-500 text-gray-500 hover:border-gray-700 hover:text-gray-700"
        type="button">
        <span class="fal fa-times"></span>
      </button>
    `
  }

}



// WEBPACK FOOTER //
// ./scripts/components/composite.js